/**
 * 资源下载
 */

import {
    get,
    post,
    put,
    del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectDataDownloadById = (Id) => {
    return get('/api/app/DataDownload?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddDataDownload = (data) => {
    return post('/api/app/DataDownload', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyDataDownload = (data) => {
    return put('/api/app/DataDownload', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataDataDownloadList = (data) => {
    return post('/api/app/dataDownload/getDataByPageQuery', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteDataDownload = (id) => {
    return del('/api/app/DataDownload/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
export const ExportInjuryUnit = (data) => {
    let defaluturl = `/api/app/DataDownload/exportExcelFile`;
    let fileName = "资料下载"
    return download(fileName, defaluturl, data);
}